export class Veiculo {
  veiculoPlaca?: string;
  isPrimeiroVeiculo?: boolean;
  isUtilizacaoAgropecuaria?: boolean;
  isZeroKm?: boolean;
  ufLicenciamento?: string;
  veiculoCategoria?: string;
  veiculoAno?: string;
  veiculoMarca?: { id: string; descricao: string };
  veiculoModelo?: { id: string; descricao: string };
  veiculoVersao?: { id: string; descricao: string; codigoMolicar?: string };
  veiculoCor?: string;
  veiculoCombustivel?: string;
  cotacao?: number;

  saved?: boolean;
  isEdit?: boolean;

  inSimular?: boolean;
  pendencia?: VeiculoPendencia;
  fipe?: string;
}

export class VeiculoPendencia {
  placa: string;
  principal: boolean;
  error: string;
}
export class VeiculoProprio {
  placa?: string;
  anoModelo?: string;
  categoria?: { id: string };
  marca?: { id: string };
  modelo?: { id: string };
  versao?: { id: string };

  status?: string;

  info?: PendenciaCaminhaoProprioInfo;
  quitado?: PendenciaCaminhaoProprioQuitado;
  implemento?: PendenciaCaminhaoProprioImplemento;
}

export class VeiculoProprioFinaliza {
  placa?: string;
  anoModelo?: string;
  categoria?: { id: string };
  marca?: { id: string };
  modelo?: { id: string };
  versao?: { id: string };

  status?: string;

  tempoPossui?: number;

  marcaImplemento?: string;
  modeloImplemento?: string;
  anoImplemento?: string;
  possuiImplemento?: string;

  valorParcelas?: number;
  totalParcelasQuitadas?: number;
  totalParcelas?: number;
  quitado?: string;

  nomeCredor?: string;
}

export class VeiculoEmSeuNome {
  isVeiculoEmMeuNome?: boolean;
  isNaoSeiPlaca?: boolean;
  veiculoPlaca?: string;
  veiculoCategoria?: string;
  veiculoAno?: string;
  veiculoMarca?: { id: string; descricao: string };
  veiculoModelo?: { id: string; descricao: string };
  veiculoVersao?: { id: string; descricao: string; codigoMolicar?: string };

  saved?: boolean;
  isEdit?: boolean;
}

export class PendenciaCaminhaoProprio {
  info?: PendenciaCaminhaoProprioInfo;
  quitado?: PendenciaCaminhaoProprioQuitado;
  implemento?: PendenciaCaminhaoProprioImplemento;
}

export class PendenciaCaminhaoProprioInfo {
  veiculoPlaca?: string;
  veiculoAno?: string;
  veiculoMarca?: { id: string; descricao?: string };
  veiculoModelo?: { id: string; descricao?: string };
  veiculoVersao?: { id: string; descricao?: string };
  tempoCaminhao?: number;
  pendencia?: boolean;

  valid?: boolean;
}

export class PendenciaCaminhaoProprioQuitado {
  veiculoQuitado?: boolean;
  totalParcela?: number;
  valorParcela?: number;
  parcelasQuitada?: number;
  banco?: { id: string; descricao?: string, codigo?: number };

  valid?: boolean;
}

export class PendenciaCaminhaoProprioImplemento {
  veiculoImplemento?: boolean;
  veiculoAno?: string;
  veiculoMarca?: { id: string; descricao: string };
  veiculoModelo?: { id: string; descricao: string };

  valid?: boolean;
}
